import { render, staticRenderFns } from "./ViewCandidateOfferDetails.vue?vue&type=template&id=e1d61c56&scoped=true&"
import script from "./ViewCandidateOfferDetails.vue?vue&type=script&lang=js&"
export * from "./ViewCandidateOfferDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViewCandidateOfferDetails.vue?vue&type=style&index=0&id=e1d61c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d61c56",
  null
  
)

export default component.exports